import { render, staticRenderFns } from "./UserGroupsEdit.vue?vue&type=template&id=283f8198&"
import script from "./UserGroupsEdit.vue?vue&type=script&lang=js&"
export * from "./UserGroupsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports